/* eslint-disable import/no-mutable-exports */
import defaultVendors from './default.json';
import { VendorT } from './types';

const vendors = defaultVendors as VendorT;

export default vendors;
